export const SET_QRY_STR_MEDIUM = "SET_MEDIUM";
export const SET_QRY_STR_SOURCE = "SET_SOURCE";
export const CLEAR_QUERY_STRINGS = "CLEAR_QUERY_STRINGS";
